import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <div className="background-gradient">
      <section className="section">
        <div className="container about-content">
        <div className="about-content__intro">
          <p className="about-content__text about-content__text--lead">
            <strong>Celestix (Селестикс)</strong> — образовательный проект, направленный на поддержку студентов, 
            повышение их вовлечённости в университетскую среду и раскрытие личного и профессионального потенциала.
          </p>
        </div>

        <div className="about-content__section card">
          <h2 className="about-content__subtitle">Возможности платформы</h2>
          <p className="about-content__text">
            Проект объединяет на одной платформе актуальные возможности для развития: мероприятия и студенческие 
            объединения, наборы в кружки и команды, заявки на волонтёрство и научную деятельность, хакатоны, 
            конкурсы, программы дополнительного образования, а также патриотические инициативы.
          </p>
        </div>

        <div className="about-content__section card">
          <h2 className="about-content__subtitle">Коммуникация и профиль активности</h2>
          <p className="about-content__text">
            В рамках Celestix предусмотрена приватная коммуникационная среда для взаимодействия участников, 
            включая обмен сообщениями, аудио- и видеосвязь, а также передачу файлов. Платформа также формирует 
            и ведёт профиль активности студента, фиксируя участие в проектах и конкурсах, достижения (награды, 
            дипломы), полученные гранты и иные результаты, отражающие динамику развития и практический опыт.
          </p>
        </div>

        <div className="about-content__section card">
          <h2 className="about-content__subtitle">Связь с работодателями</h2>
          <p className="about-content__text">
            Отдельным направлением проекта является взаимодействие с работодателями. Celestix предоставляет 
            работодателям доступ к информации об активных и мотивированных участниках, что позволяет компаниям 
            оперативно находить потенциальных кандидатов и напрямую связываться со студентами для приглашения 
            на стажировку, практику или трудоустройство.
          </p>
        </div>
        </div>
      </section>
    </div>
  );
};

export default About;
